var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field org-user-select" },
    [
      _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
      _vm.subText
        ? _c("span", {
            staticClass: "sub-text",
            domProps: { textContent: _vm._s(_vm.subText) },
          })
        : _vm._e(),
      _vm.showInfoText
        ? _c("span", {
            class: _vm.infoTextClass,
            domProps: { textContent: _vm._s(_vm.infoText) },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "control" },
        [
          _c("multiselect", {
            attrs: {
              "track-by": "id",
              "custom-label": _vm.fieldLabel,
              options: _vm.users,
              value: _vm.myValue,
              searchable: true,
              loading: _vm.isFetching,
              "deselect-label": "Press enter to clear",
              disabled: _vm.disabled,
            },
            on: { input: _vm.myBlur },
          }),
        ],
        1
      ),
      _vm.showUser && _vm.myValue
        ? _c("user-card", {
            staticClass: "selected-user",
            attrs: {
              user: _vm.myValue,
              "show-details": true,
              size: "is-64x64",
            },
          })
        : _vm._e(),
      _vm.showError
        ? _c("p", { staticClass: "help is-danger" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm.myValue && _vm.myValue.status !== "active" && _vm.shouldBeActive
        ? _c("div", { staticClass: "message is-warning mt-2" }, [
            _c("div", { staticClass: "message-body" }, [
              _vm._v(
                " This user is not active, they won’t receive site tour requests, contact Sally for help. "
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }